// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://penmwkkscgueyytcical.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBlbm13a2tzY2d1ZXl5dGNpY2FsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg0NDQ1MDcsImV4cCI6MjA3NDAyMDUwN30.z3Rp6fbN10MPsp8CCaEISF5SSXhpo_Geu7jh3pW85mw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});